import { IUsageType } from "../interface/IUsageType";

interface IUsageTypeContentResponse {
    key: string;
    ratingSubtotalDisplayName: string;
}

export interface IUsageTypeResponse {
    ratingSubtotalTypes: IUsageTypeContentResponse[];
}

export const getResponseToState = (response: IUsageTypeResponse): IUsageType[] =>
    response.ratingSubtotalTypes.map((usageType) => ({
        key: usageType.key,
        name: usageType.ratingSubtotalDisplayName,
    }));
